import React, { ReactElement } from "react";
import {ObjectFieldTemplateProps, canExpand, TranslatableString} from "@rjsf/utils";
import SpaceBetween from "@amzn/awsui-components-react-v3/polaris/space-between";
import Box from "@amzn/awsui-components-react-v3/polaris/box";
import Button from "@amzn/awsui-components-react-v3/polaris/button";

export default function ObjectFieldTemplate(
  props: ObjectFieldTemplateProps
): ReactElement {
  return (
    <SpaceBetween size="l">
      {props.properties.map((element, index) => (
        <React.Fragment key={index}>{element.content}</React.Fragment>
      ))}
      {canExpand(props.schema, props.uiSchema, props.formData) ? (
        <Box float="left">
          <Button
            formAction="none"
            iconName="add-plus"
            onClick={props.onAddClick(props.schema)}
            disabled={props.disabled || props.readonly}
          >{props.registry.translateString(TranslatableString.AddItemButton)}</Button>
        </Box>
      ) : null}
    </SpaceBetween>
  );
}
